// extracted by mini-css-extract-plugin
export default {"loading":"h5_loading__RFPRX","pcWrap":"h5_pcWrap__5Kobg"};